<template>
    <div class="container-div">
        <NavBarLight></NavBarLight><br><br>
        <div class="dashboard-content-learn">
            <div class="row">
                <!--<div>    
                    <h1 class="text-left heading-learning">Learn real-world concepts for <b>free</b></h1>
                    <div class="text-left">User Interface and User Experience Design (UI/UX) is responsible for the smooth flows and ease-of-use of mobile apps and websites all around you. <br><br><br>From all kinds of apps - food delivery, ride sharing, games, banking, etc. to all 
                    kinds of form factors - desktop, mobile, tablets, watches, TVs, etc. UI/UX is the glue that binds users with technology. Pick your favourite product and you'll notice how UI/UX is responsible for the functional and beautiful experience.<br><br><br>You can learn Design (UI/UX) concepts created by design experts. You can also practice concepts to test your knowledge and see where you stand.</div>
                </div>
                <b-button v-on:click="startLearning" class="signup-btn">START LEARNING</b-button><br><br>
            -->
                <h1 class="text-left heading-learning">Learn real-world concepts</h1>
                <div class="container" id="learn-cards">
                    <div class="row">
                        <LearnCard v-on:click.native="startLearning('react')" skill="React Basics" class="learn-card" iconUrl="https://pp-storage-images.s3.amazonaws.com/reactxl.svg"></LearnCard>
                        <LearnCard v-on:click.native="startLearning('react-native')" skill="React Native Basics" class="learn-card" iconUrl="https://pp-storage-images.s3.amazonaws.com/reactxl.svg"></LearnCard>
                        <LearnCard v-on:click.native="startLearning('ui-design')" skill="UI Design Basics" class="learn-card" iconUrl="https://pp-storage-images.s3.amazonaws.com/uidesignxl.svg"></LearnCard>
                        <LearnCard v-on:click.native="startLearning('js')" comingSoon skill="Modern JavaScript" class="learn-card" iconUrl="https://pp-storage-images.s3.amazonaws.com/js_logo_vector+(1).svg"></LearnCard>
                        <LearnCard v-on:click.native="startLearning('vue')" comingSoon skill="Vue Basics" class="learn-card" iconUrl="https://pp-storage-images.s3.amazonaws.com/vue_logo_vector+(1).svg"></LearnCard>
                        <LearnCard v-on:click.native="startLearning('ux-design')" comingSoon skill="UX Design Basics" class="learn-card" iconUrl="https://pp-storage-images.s3.amazonaws.com/uxdesignxl.svg"></LearnCard>
                
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import NavBarLight from '@/components/NavBarLight.vue'
import firebase from '../services/firebase'
import LearnCard from '@/components/LearnCard.vue'

export default {
    name: 'LearnDashboard',
    components: {
        NavBarLight,
        LearnCard
    },
    methods: {
        startLearning: function(sent_slug) {
            console.log("taking you to learn" + sent_slug);
            
            mixpanel.track("clicked on " + sent_slug, {
                "learning_module": sent_slug,
                "user_id": firebase.auth().currentUser.uid,
                "email": firebase.auth().currentUser.email
            });

            if (sent_slug === 'react' || sent_slug === 'react-native' || sent_slug === 'ui-design') {
                this.$router.push(this.$route.path + '/' + sent_slug + '/start-learning');
            }
            
        }
    }
}
</script>


<style scoped>

    .container-div {
        font-family: Avenir;
    }

    .dashboard-content-learn {
        padding-top:40px;
        background-color: #fff;
    }

    .heading-learning {
        margin-left: 14.7%;
        margin-right: 14.7%;
        font-size: 1.55rem;
        margin-top: 1%;
    }
    
    .signup-btn:hover {
        background-color:#f25792;
        color: #fff;
        border-color: #f25792;
    }
    @media (min-width:992px) {
       .signup-btn {
            margin-top:8%;
            padding-top:1.9%;
            padding-bottom:1.9%;
            padding-left:2.8%;
            padding-right:2.8%;
            justify-content: center;
            align-self: center;
            width:30%;
            margin-bottom:0.5%;
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.8rem;
            cursor: pointer;
            border-radius:7px;
            font-weight:500px;
        }    
    }
    @media (max-width:991px) {
       .signup-btn {
            margin-top:8%;
            padding-top:1.9%;
            padding-bottom:1.9%;
            padding-left:2.8%;
            padding-right:2.8%;
            justify-content: center;
            align-self: center;
            width:40%;
            margin-bottom:0.5%;
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.8rem;
            cursor: pointer;
            border-radius:7px;
            font-weight:500px;
        }    
    }
    @media (max-width:600px) {
       .signup-btn {
            margin-top:15%;
            padding-top:3%;
            padding-bottom:3%;
            padding-left:2.8%;
            padding-right:2.8%;
            justify-content: center;
            align-self: center;
            width:60%;
            margin-bottom:0.5%;
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.8rem;
            cursor: pointer;
            border-radius:7px;
            font-weight:500px;
        }    
    }


    .learn-card{
        width:30%;
    }

    #learn-cards {
        margin-top:1.9%;
    }

    @media (min-width: 768px) and (max-width: 992px) {
        .learn-card {
            width: 45%;
        }

        #header-image {
            margin-top:3%; 
            color:#555;
            margin-left:16%;
            margin-right:13%;
            margin-bottom:20px;
        }
    }

    @media (min-width: 600px) and (max-width: 768px) {
        .learn-card {
            width: 70%;
            margin: auto;
        }

        #header-image {
            margin-top:2%; 
            color:#555;
            margin-left:5%;
            margin-right:5%;
            margin-bottom:20px;
        }

    }

    @media (min-width: 430px) and (max-width:600px) {
        .learn-card {
            width: 80%;
            margin: auto;
        }

        #header-image {
            margin-top:7%; 
            color:#555;
            margin-left:10%;
            margin-right:10%;
            margin-bottom:20px;
        }

    }

    @media (max-width:430px) {
        .learn-card {
            width: 90%;
            margin:auto;
        }

        #header-image {
            margin-top:11%; 
            color:#555;
            margin-left:5%;
            margin-right:5%;
            margin-bottom:20px;
        }
    }

    @media (min-width: 768px) {
        #learn-cards {
            margin-left: 11.9%;
            margin-right: 11.9%;
        }
    }


</style>
